import { TInitialState } from '~/src/features/tariffBuilder/reducer';
import { EEntity } from '~/src/features/tariffBuilder/types/EEntity';

const getSpeedLines = (state: TInitialState) => state[EEntity.speed];

export default getSpeedLines;
